import React, { useEffect, useState, useRef } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../config";
import Swal from "sweetalert2";
import { triggerNotification } from "../../component/message/Msg";
import TableViewer from "../../component/tableViewer/TableViewer";

const ViewMcqBank = () => {
  const token = config.token;
  const { bankfor, id } = useParams();
  const navigate = useNavigate();

  //------------------------------------------- State management -------------------------------------------
  const [loading, setLoading] = useState(false);
  const [mcqBanks, setMcqBanks] = useState([]);
  const [bankFor, setBankFor] = useState({
    bFor: "chapterid",
    cid: "",
    chapters: [],
    courses: [],
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  //  ------For TableViewer ------
  const banksRef = useRef([]);
  banksRef.current = mcqBanks;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  const handleChapCourChangeDropdown = (value) => {
    // console.log("func call");
    setBankFor((prevData) => ({
      ...prevData,
      cid: value,
    }));
    setLoading(true);
    //fetch mcq bank
    fetch(
      `${config.host_url}mcqbanks/${bankFor.bFor === "courseid" ? "course" : "chapter"
      }/${value}`,
      {
        method: "GET",
        headers: {
          token,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("bank:", data.data);
        setMcqBanks(data.data);

        const banksData = data.data.map((bank) => ({
          bank_name: bank.bank_name,
          pattern: bank.pattern,
          isFree: bank.isFree,
          set_exam_timer: bank.set_exam_timer,
          exam_timer: bank.exam_timer,
          set_que_timer: bank.set_que_timer,
          que_timer: bank.que_timer,
          set_warning: bank.set_warning,
          warning_seconds: bank.warning_seconds,
          idNumber: bank.mbid,
        }));
        setRowData(banksData);
      });
    setLoading(false);
  };

  //-------------------------------------- fetch data form prameters ----------------------------------------
  useEffect(() => {
    if (id !== undefined) {
      setBankFor((prevData) => ({
        ...prevData,
        bFor: bankfor,
        cid: decodeURIComponent(atob(id)),
      }));

      setLoading(true);
      //fetch mcq bank
      fetch(
        `${config.host_url}mcqbanks/${bankfor === "courseid" ? "course" : "chapter"
        }/${decodeURIComponent(atob(id))}`,
        {
          method: "GET",
          headers: {
            token,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log("bank:", data.data);
          setMcqBanks(data.data);
          //  ------For TableViewer ------
          const banksData = data.data.map((bank) => ({
            bank_name: bank.bank_name,
            pattern: bank.pattern,
            isFree: bank.isFree,
            set_exam_timer: bank.set_exam_timer,
            exam_timer: bank.exam_timer,
            set_que_timer: bank.set_que_timer,
            que_timer: bank.que_timer,
            set_warning: bank.set_warning,
            warning_seconds: bank.warning_seconds,
            idNumber: bank.mbid,
          }));
          setRowData(banksData);
          //  ------For TableViewer ------
        });
      setLoading(false);
    }
  }, [id]);

  //-------------------------------------- get chapter/course for dropdown option --------------------------------------r
  useEffect(() => {
    // Fetch chapter list
    setLoading(true);
    fetch(`${config.host_url}chapter`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setBankFor((prevData) => ({
            ...prevData,
            chapters: data.data,
          }));
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching chapter:", error);
      });

    // Fetch course list
    fetch(`${config.host_url}course`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setBankFor((prevData) => ({
            ...prevData,
            courses: data.data,
          }));
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching course:", error);
      });
    setLoading(false);
  }, [token]);

  // ------------------------------------------------------------------ Delete MCQ Bank -----------------------------------------------------D
  const handleDeleteBtn = (id, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete MCQ Bank. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id, i);
      }
    });
    //Confirm delete
    const handleDelete = (id, i) => {
      fetch(`${config.host_url}mcqbanks/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
      })
        .then(function (response) {
          // console.log("Response:", response);
          return response.json();
        })
        .then(function (data) {
          // console.log("Data:", data);
          if (data.status === 200) {
            triggerNotification("success", "MCQ Bank deleted successfully");

            //  ------For TableViewer ------
            const updatedMCQBank = [...banksRef.current];
            updatedMCQBank.splice(i, 1);
            setMcqBanks(updatedMCQBank);

            const banksData = updatedMCQBank.map((bank) => ({
              bank_name: bank.bank_name,
              pattern: bank.pattern,
              isFree: bank.isFree,
              set_exam_timer: bank.set_exam_timer,
              exam_timer: bank.exam_timer,
              set_que_timer: bank.set_que_timer,
              que_timer: bank.que_timer,
              set_warning: bank.set_warning,
              warning_seconds: bank.warning_seconds,
              idNumber: bank.mbid,
            }));
            setRowData(banksData);
            //  ------For TableViewer ------
          } else if (data.status === 404) {
            triggerNotification("error", "MCQ Bank not found");
          } else if (data.status === 401) {
            triggerNotification("error", "Unauthenticated User");
          } else {
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        })
        .catch(function (error) {
          console.error("Error:", error);
          triggerNotification("error", "Error deleting MCQ Bank");
        });
    };
  };


  // ------------------------------------------------------------------ edit MCQ Bank -----------------------------------------------------U
  const handleEditBtn = (id) => {
    navigate(`/addmcqbank/${btoa(encodeURIComponent(id))}`);
  };

  //---------------------------------------------- bank for course or chapter ----------------------------------------------
  const handleRadioChange = (e) => {
    if (e.target.value === "courseid") {
      setMcqBanks([]);
      setBankFor((prevData) => ({
        ...prevData,
        cid: "",
        bFor: "courseid",
      }));
    } else if (e.target.value === "chapterid") {
      setMcqBanks([]);
      setBankFor((prevData) => ({
        ...prevData,
        cid: "",
        bFor: "chapterid",
      }));
    }
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    { field: "bank_name", filter: true, headerName: "Bank Name" },
    { field: "pattern", filter: true, width: 120 },
    {
      field: "isFree",
      headerName: "Is Free?",
      filter: true,
      width: 150,
      valueFormatter: (params) => {
        return params.data.isFree === 1 ? "Free" : "Not Free";
      },
    },
    {
      field: "set_exam_timer",
      headerName: "Exam Timer (In Minutes)",
      filter: true,
      width: 225,
      valueFormatter: (params) => {
        return params.data.set_exam_timer === 1 ? params.data.exam_timer : "NA";
      },
    },
    {
      field: "set_que_timer",
      headerName: "Question Timer (In Minutes)",
      filter: true,
      width: 230,
      valueFormatter: (params) => {
        return params.data.set_que_timer === 1 ? params.data.que_timer : "NA";
      },
    },
    {
      field: "set_warning",
      headerName: "Warning Timer (In Minutes)",
      filter: true,
      width: 225,
      valueFormatter: (params) => {
        return params.data.set_warning === 1
          ? params.data.warning_seconds
          : "NA";
      },
    },
  ];

  // Filtered options based on the search term
  const filteredOptions = bankFor.bFor === "chapterid"
    ? bankFor.chapters.filter((chapter) => chapter.name.toLowerCase().includes(searchTerm.toLowerCase()))
    : bankFor.bFor === "courseid"
      ? bankFor.courses.filter((course) => course.course_name.toLowerCase().includes(searchTerm.toLowerCase()))
      : [];

  // Handle option selection
  const handleOptionSelect = (event, value) => {
    handleChapCourChangeDropdown(value);
    setIsDropdownOpen(false);
  };

  //  ------For TableViewer ------

  return (
    <>
      <Breadcrumb txt="Manage MCQ " subpath={["View MCQ Banks"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">View MCQ Banks</h5>
            <div>
              <button
                type="button"
                className="btn btn-primary ml-4"
                onClick={() => {
                  navigate("/addmcqbank");
                }}
              >
                Add MCQ Bank
              </button>
            </div>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3 row mx-4">
              {/* chapter / course selection  */}
              <div className="flex items-center">
                <label className="form-check-label ml-1 mr-6">
                  MCQ Bank For
                </label>
                <div className="col mt-2">
                  <div className="form-check form-check-inline ml-1">
                    <input
                      defaultChecked
                      name="form-check-group-image"
                      className="form-check-input"
                      type="radio"
                      value="chapterid"
                      id="chapter"
                      checked={bankFor.bFor === "chapterid"}
                      onChange={handleRadioChange}
                    />
                    <label className="form-check-label" htmlFor="chapter">
                      Chapter
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      name="form-check-group-image"
                      className="form-check-input"
                      type="radio"
                      value="courseid"
                      id="course"
                      checked={bankFor.bFor === "courseid"}
                      onChange={handleRadioChange}
                    />
                    <label className="form-check-label" htmlFor="course">
                      Course
                    </label>
                  </div>
                </div>
              </div>

              {/* chapter / course   */}
              <div className="col-md-12 mt-2 position-relative">
                <div className="form-floating form-floating-outline mb-4">
                  <div
                    className={`form-control w-100`}
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    style={{ cursor: 'pointer' }}
                  >
                    {bankFor.cid
                      ? bankFor.bFor === "chapterid"
                        ? bankFor.chapters.find(chapter => chapter.chapterid === bankFor.cid)?.name
                        : bankFor.courses.find(course => course.course_id === bankFor.cid)?.course_name
                      : bankFor.bFor === "chapterid"
                        ? "---- Select Chapter ----"
                        : bankFor.bFor === "courseid"
                          ? "---- Select Course ----"
                          : "Please first select MCQ Bank For"}
                  </div>

                  {isDropdownOpen && (
                    <div className="dropdown-menu show w-100 p-2" style={{ maxHeight: '200px', overflowY: 'auto', position: 'absolute', top: '100%', left: '0', zIndex: '1000' }}>
                      {/* Search Input */}
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        autoFocus
                      />

                      {/* Options */}
                      {filteredOptions.length > 0 ? (
                        filteredOptions.map((option, index) => (
                          <div
                            key={index}
                            className="dropdown-item"
                            onClick={(e) => handleOptionSelect(e, bankFor.bFor === "chapterid" ? option.chapterid : option.course_id)}
                            style={{ cursor: 'pointer' }}
                          >
                            {bankFor.bFor === "chapterid" ? option.name : option.course_name}
                          </div>
                        ))
                      ) : (
                        <div className="dropdown-item text-muted">No options found</div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* ------For TableViewer ------ */}
              {bankFor.cid !== "" && (
                <TableViewer
                  rowData={rowData}
                  colDefs={colDefs}
                  onEdit={handleEditBtn}
                  onDelete={handleDeleteBtn}
                  onExport
                />
              )}
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewMcqBank;
